import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-x600hgateway",
  "use": "icon-soc-m-x600hgateway-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-x600hgateway\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"300\" cy=\"180\" r=\"28\" /><rect x=\"160\" y=\"224\" width=\"704\" height=\"480\" rx=\"32\" /><path d=\"M224 288h576v352H224z\" fill=\"#fff\" fill-opacity=\".2\" /><path d=\"M384 704h256v64H384zM320 768h384v48H320z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-x600hgateway.svg
// module id = BLBp
// module chunks = 477